<div class="career-page-container">
  <app-navbar></app-navbar>
  <div class="header d-flexbox">
    <div class="header-content d-flexbox col">
      <!-- <div class="btn btn-hover bg-secondary-color" (click)="whatsApp()">Quick Help</div> -->
      <div class="big-caption text-default-color" style="padding: 20px">
        Register for any of our courses, and learn a fortune
      </div>
    </div>
  </div>

  <div class="form-wrapper d-flexbox col">
    <h2>You can also send us a request</h2>
    <form
      class="form d-flexbox col justify-content-left align-items-top"
      [formGroup]="contactUsForm"
      (ngSubmit)="submit()"
    >
      <label for="firstName" class="caption-primary-color">First name</label>
      <input
        type="text"
        id="firstName"
        formControlName="firstName"
        placeholder="Ex. Jane"
      />
      <div
        *ngIf="
          contactUsForm.get('firstName').invalid &&
          contactUsForm.get('firstName').touched
        "
      >
        <small
          *ngIf="
            contactUsForm.get('firstName').invalid &&
            contactUsForm.get('firstName').touched
          "
          style="color: red"
        >
          *First name is required</small
        >
      </div>

      <label for="lastName" class="caption-primary-color">Last name</label>
      <input type="text" formControlName="lastName" placeholder="Ex. Tailor" />
      <div
        *ngIf="
          contactUsForm.get('lastName').invalid &&
          contactUsForm.get('lastName').touched
        "
      >
        <small
          *ngIf="
            contactUsForm.get('lastName').invalid &&
            contactUsForm.get('lastName').touched
          "
          style="color: red"
        >
          *Last name is required</small
        >
      </div>
      <label for="email" class="caption-primary-color">Mobile Number</label>
      <input type="tel" formControlName="mobile" placeholder="08012345678"  [maxLength]="15"/>
      <div
        *ngIf="
          contactUsForm.get('mobile').invalid &&
          contactUsForm.get('mobile').touched
        "
      >
        <small
          *ngIf="
            contactUsForm.get('mobile').invalid &&
            contactUsForm.get('mobile').touched
          "
          style="color: red"
        >
          *Mobile is required</small
        >
      </div>

      <label for="email" class="caption-primary-color">Email</label>
      <input
        type="email"
        formControlName="email"
        placeholder="example@mail.com"
        required="required"
      />
      <div
        *ngIf="
          contactUsForm.get('email').invalid &&
          contactUsForm.get('email').touched
        "
      >
        <small
          *ngIf="
            contactUsForm.get('email').invalid &&
            contactUsForm.get('email').touched
          "
          style="color: red"
        >
          *Your email is required</small
        >
      </div>

      <label for="Subject" class="caption-primary-color">Subject</label>
      <input type="text" formControlName="subject" placeholder="Help on..." />
      <div
        *ngIf="
          contactUsForm.get('subject').invalid &&
          contactUsForm.get('subject').touched
        "
      >
        <small
          *ngIf="
            contactUsForm.get('subject').invalid &&
            contactUsForm.get('subject').touched
          "
          style="color: red"
        >
          *Subject is required</small
        >
      </div>

      <label for="tellUsMore">Message *</label>

      <textarea
        formControlName="message"
        id="tellUsMore"
        cols="30"
        rows="8"
        placeholder="Leave a message"
      ></textarea>
      <div
        *ngIf="
          contactUsForm.get('message').invalid &&
          contactUsForm.get('message').touched
        "
      >
        <small
          *ngIf="
            contactUsForm.get('message').invalid &&
            contactUsForm.get('message').touched
          "
          style="color: red"
        >
          *Message is required</small
        >
      </div>
      <input type="submit" value="Submit a request" />
    </form>
  </div>


  <!-- footer -->
  <app-footer></app-footer>
  <!-- end of footer -->

  <app-back-to-top
    [acceleration]="2"
    [animate]="true"
    [scrollDistance]="50"
    [speed]="50"
  >
  </app-back-to-top>
</div>
